let he = {
   january: 'ינואר',
   february: 'פברואר',
   march: 'מרץ',
   april: 'אפריל',
   may: 'מאי',
   june: 'יוני',
   july: 'יולי',
   august: 'אוגוסט',
   september: 'ספטמבר',
   doYouHaveQuestions: 'יש לכם שאלה? רוצים לדעת עוד?',
   contactUs: 'צרו קשר עם נציג תמיכה טכנית',
   october: 'אוקטובר',
   november: 'נובמבר',
   december: 'דצמבר',
   bank: 'בנק',
   paymentDate: 'מועד תשלום',
   emailAddress: 'כתובת אי-מייל',
   amountToPay: 'סכום לתשלום',
   fourDigits: '4 ספרות',
   amount: 'סכום',
   loginToSystem: 'התחברות למערכת',
   checks: 'שיקים',
   paymentRef: 'אסמכתא',
   checkNumber: 'מספר שיק',
   birthDate: 'תאריך לידה',
   mngCompany: 'חברת ניהול',
   lastName: 'שם משפחה',
   account: 'חשבון',
   accountNumber: 'מספר חשבון',
   branch: 'סניף',
   password: 'סיסמה',
   position: 'תפקיד',
   cantChangePaid: 'לא ניתן לשנות תשלום שכבר שולם',
   choosePosition: 'בחר תפקיד',
   vaadMissingMsg:
      'לא מוגדרים חברי ועד הבית, הדבר מונע מוועד הבית כניסה לאזור האישי באפליקציה וצפייה בדוחות',
   buildingBankAccountMissingMsg:
      'חשבון הבנק לא מוגדר במערכת',
   lowerThanPaidErrorMsg: 'לא ניתן להגדיר סכום נמוך מהסכום שכבר שולם',
   exportAccounting: 'יצוא תנועות הנה"ח',
   extra: 'נוסף',
   tenant: 'דייר',
   tenantName: 'שם שוכר',
   extraTenant: 'שוכר נוסף',
   number: 'מספר',
   name: 'שם',
   yearly: 'שנתי',
   phoneNumber: 'טלפון',
   phone: 'טלפון',
   mobilePhone: 'טלפון נייד',
   extraPhone: 'טלפון נוסף',
   total: 'סה"כ',
   mail: 'מייל',
   email: 'דוא"ל',
   contactReason: 'סיבת פנייה',
   size: 'גודל',
   m2: 'מ"ר',
   note: 'הערה',
   blog: 'בלוג',
   about: 'אודות',
   privacy: 'פרטיות',
   terms: 'תנאי שימוש',
   career: 'קריירה',
   publicComplaintsUnit: 'יחידת תלונות הציבור',
   status: 'סטטוס',
   available: 'פעיל',
   unavailable: 'לא פעיל',
   verifyBank: 'המשך לאימות חשבון',
   inLegalProcess: 'בטיפול משפטי',
   resultsNotFound: 'לא נמצאו תוצאות המתאימות לחיפוש',
   files: 'קבצים',
   exit: 'יציאה',
   saveWithoutVerification: 'שמירה ללא אימות',
   uploadExcelFile: 'העלה קובץ אקסל',
   exportExcelList: 'יצא רשימה לאקסל',
   exportListToPDF: 'יצא רשימה ל PDF',
   printList: 'הדפס רשימה',
   buildingFees: 'וועד בית',
   listedUnder: 'הרשומים תחת',
   listOf: 'רשימת',
   deleteOf: 'מחיקת',
   addingOf: 'הוספת',
   editOf: 'עריכת',
   detailsOf: 'פרטי',
   firstName: 'שם פרטי',
   ownerOf: 'בעל ה',
   breakDate: 'תאריך הפסקה',
   cancel: 'ביטול',
   dateCreated: 'תאריך הקמה',
   lastUpdate: 'עדכון אחרון',
   updateBy: ', עודכן ע"י',
   add: 'הוסף',
   apt: 'דירה',
   other: 'אחר',
   save: 'שמור',
   notes: 'הערות',
   zu: 'זו',
   apartmentList: {
      expensesFundingPercent: 'אחוז השתתפות בהוצאות',
      mutualPropertyPercent: '% מהרכוש המשותף',
      availableApts: 'יחידות פעילות',
      notAvailableApts: 'יחידות לא פעילות',
      youreAboutToUpdateStatus: 'הנך עומד לשנות סטטוס',
      youreAboutToDelete: 'הנך עומד למחוק את',
      toAvailable: 'למצב פעיל',
      paymentNote: 'הערת תשלום',
      monthlyPayment: 'תשלום חודשי',
      monthlyPaymentAmount: 'סכום תשלום חודשי',
      deleteActionConfirm: 'פעולה זה תגרום למחיקתם של כל הקבלות, תשלומים וה',
      note1: 'סימון יחידה כלא פעילה תנתק את הוראת הקבע של היחידה במידה וקיימות',
      note2: 'ותעביר את היחידה ואת רישומיה לארכיון יחידות לא פעיל.',
      note3: 'ניתן לבטל פעולה זו בכל עת.',
      note4: 'מקם כיחידה הראשונה ברשימה',
      note5: 'הוגדרה בהצלחה כלא פעילה',
      updatedSuccesfully: 'עודכנו בהצלחה',
      shift: 'הפוך ',
      toUnavialble: ' ללא פעילה',
      locateAfter: 'מקם אחרי',
      relocateApt: 'שנה מיקום ',
      defineAptLocation: 'הגדר מיקום ',
      unavailable: 'לא פעילה',
      placeholder: 'חפש שם / מספר',
      addedSuccessfully: 'נוספה בהצלחה',
      paymentStart: 'תחילת תשלום',
      size: 'גודל דירה',
      apartmentLocatedFirst: 'דירה זו ראשונה ברשימה',
   },
   landingPage: {
      download: 'הורדה',
      firstH1: 'הבית זה איפה שגם הלב',
      secondH1: 'שלכם נמצא',
      firstP:
         'דרך חדשה ונוחה לניהול בניינים באמצעות שירותים',
      secondP:
         'טכנולוגיים מתקדמים שנותנים ערך מוסף למגורים בבניין.',
   },
   apartmentPage: {
      payments: {
         disabledApartmentPaymentError:
            'לא ניתן לבצע תשלומים עבור דירה לא פעילה',
      },
   },
   fileSizeErr: 'לא ניתן להעלות קובץ שגודלו מעל 10MB',
   AddBankAccountWarning: 'שימו לב! לא ניתן להשתמש ברשיון נהיגה לצורך אישור חשבון',
   closedCall: 'קריאה נסגרה ',
   pickAdate: 'בחר תאריך',
   expensesNotFound: 'לא נמצאו הוצאות',
   balance: 'יתרה',
   amountIsMissing: 'לא הוזן סכום לתשלום',
   currentExpenses: 'הוצאות שוטפות',
   additionalExpenses: 'הוצאות נוספות',
   description: 'תיאור',
   expenseSubject: 'סוג הוצאה',
   provider: 'ספק',
   longLoading:'טעינת המידע אורכת כ-30 שניות... אנא המתן',
   loading:'טוען מידע... אנא המתן',
   buildingName: 'שם בניין',
   companyNameHasChanged: 'שם החברה בקבלה שונה בהצלחה',
   technicalErr: 'ישנה שגיאה טכנית. נא לנסות מאוחר יותר או לדווח לצוות OXS, תודה.',
   setLogoSuccess: 'לוגו נטען בהצלחה',
   creditTokenKeeping: 'פרטי אשראי',
   savedCreditToken: 'שמירה באופן מוצפן.',
   unSavedCreditToken: 'פרטים לא שמורים!',
   savedCreditTokenText1_1: 'בתשלום הבא אין צורך',
   savedCreditTokenText1_2: 'בפרטי כרטיס',
   unSavedCreditTokenText1_1: 'בכל תשלום יש להזין',
   unSavedCreditTokenText1_2: 'פרטי כרטיס מחדש',
   unSavedCreditTokenText1_3: 'הו"ק לא פעילה',
   wrongFileAlert: 'העלאה נכשלה',
   ccPartialPaymentLimitiation: 'פעולה לא ניתנת לביצוע. נא לבחור תשלום חלקי אחד בלבד'
}

export default he

// $t('')

// {{$t('')}}

// ${$t('')}

// this.$t('')

// {{this.$t('')}}

// ${this.$t('')}



// WEBPACK FOOTER //
// ./src/lang/types/he.js